import React, { useState } from "react";
import {
  TextField,
  Button,
  Paper,
  Typography,
  Container,
  Box,
  Avatar,
  Link,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import axios from "../../api/axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const response = await axios.post("/auth/forgot-password", { email });
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.message || "Error sending reset email");
    }
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Paper elevation={2} sx={{ padding: 3, mt: 10, borderRadius: 2 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar sx={{ m: 1, bgcolor: "primary.main", width: 40, height: 40 }}>
            <LockOutlinedIcon fontSize="small" />
          </Avatar>
          <Typography variant="h6" gutterBottom>
            Forgot Password
          </Typography>
          {error && <Typography color="error">{error}</Typography>}
          {message && <Typography color="primary">{message}</Typography>}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              size="small"
              margin="dense"
              value={email}
              onChange={handleChange}
              required
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              size="small"
              sx={{ mt: 2 }}
            >
              Submit
            </Button>
            <Box mt={2} display="flex" justifyContent="space-between">
              <Link
                href="/login"
                variant="body2"
                sx={{ color: "#fff", textDecoration: "none" }}
              >
                Go back to Login?
              </Link>
            </Box>
          </form>
        </Box>
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
